import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CalculatorPro from './CalculatorPro';
import CalculatorMobile from './CalculatorMobile';
import Layout from '../Layout/Layout';
import { useAuth } from '../../contexts/AuthContext';

// Detect if device is mobile
const isMobileDevice = () => {
  // Check if it's a touch device
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check screen width - consider tablets up to 900px as mobile for better usability
  const isSmallScreen = window.innerWidth < 900;

  // Check user agent for mobile devices (exclude iPads)
  const mobileRegex = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileUserAgent = mobileRegex.test(navigator.userAgent) && !navigator.userAgent.includes('iPad');

  // Check orientation and screen size
  const isPortrait = window.innerHeight > window.innerWidth;
  const isSmallDevice = window.innerWidth < 900 && isPortrait;

  // Return true for small/medium devices in portrait or mobile user agents
  return (isTouchDevice && isSmallDevice) || (isMobileUserAgent && isSmallScreen);
};

const ClientHeader = styled.header`
  background-color: #2c3e50;
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
`;

const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

const UserName = styled.span`
  font-size: 0.95rem;
`;

const LogoutButton = styled.button`
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s;

  &:hover {
    background-color: #c0392b;
  }
`;

const CalculatorWrapper = () => {
  const { isAdmin, user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(isMobileDevice());

  useEffect(() => {
    // Handle resize events
    const handleResize = () => {
      setIsMobile(isMobileDevice());
    };

    window.addEventListener('resize', handleResize);

    // Check on orientation change
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  const handleLogout = () => {
    logout();
    toast.info('Sesión cerrada');
    navigate('/login');
  };

  // Allow manual override with URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const forceDesktop = urlParams.get('desktop') === 'true';
  const forceMobile = urlParams.get('mobile') === 'true';

  // Determine which calculator component to render
  let calculatorComponent;
  if (forceDesktop) {
    calculatorComponent = <CalculatorPro />;
  } else if (forceMobile || isMobile) {
    calculatorComponent = <CalculatorMobile />;
  } else {
    calculatorComponent = <CalculatorPro />;
  }

  // If admin, wrap with Layout (full menu)
  if (isAdmin) {
    return <Layout>{calculatorComponent}</Layout>;
  }

  // If not admin, show simple header with logout only
  return (
    <>
      <ClientHeader>
        <Title>Calculadora ILTZAR</Title>
        <UserSection>
          <UserName>
            {user?.firstName} {user?.lastName}
          </UserName>
          <LogoutButton onClick={handleLogout}>
            Cerrar Sesión
          </LogoutButton>
        </UserSection>
      </ClientHeader>
      {calculatorComponent}
    </>
  );
};

export default CalculatorWrapper;